export const MINT_PASS_COUNT_LIMIT = 5;
export const ENS_PROMO_DISCOUNT_PRICE = 15;
export const FREE_SUB_DOMAIN_NAME = 'me';
